// URL profile dạng slug: {tên-đã-slug}-{sequenceId} (vd "vinga-magic-1024").
// Không lộ email. Fallback "user-{sequenceId}" khi chưa có tên.

const slugify = (s: string) =>
  (s || '')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '') // bỏ dấu tiếng Việt
    .replace(/đ/g, 'd')
    .replace(/Đ/g, 'D')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 40);

/** Dựng slug profile từ tên + sequenceId. Nếu thiếu seqId → trả về fallback (id/username). */
export const buildProfileSlug = (
  fullname?: string,
  sequenceId?: number | null,
  fallback?: string
): string => {
  if (!sequenceId) return fallback || '';
  const base = slugify(fullname || '');
  return base ? `${base}-${sequenceId}` : `user-${sequenceId}`;
};

/**
 * Lấy sequenceId từ slug: BẮT BUỘC có dấu "-" ngay trước số cuối
 * ("vinga-magic-1024" → 1024, "user-1024" → 1024).
 * Trả null với email/username (kể cả username kết thúc bằng số như "latoca2758")
 * để không nhầm → fetch theo username như cũ.
 */
export const parseSequenceId = (slug?: string): number | null => {
  if (!slug) return null;
  const m = /-(\d+)$/.exec(slug.trim());
  return m ? Number(m[1]) : null;
};
